import { HeartHandshake, ShieldCheck, Clock3 } from "lucide-react";

const points = [
  {
    Icon: HeartHandshake,
    title: "Sans jugement",
    desc: "Un ton humain, des mots simples. Pas de jargon médical qui fait peur.",
  },
  {
    Icon: ShieldCheck,
    title: "Privé par défaut",
    desc: "Tes données restent tes données. Chiffrées, jamais revendues.",
  },
  {
    Icon: Clock3,
    title: "30 secondes par jour",
    desc: "Conçue pour être ouverte en coup de vent, entre deux toilettes.",
  },
];

export default function HowItWorks() {
  return (
    <section
      data-testid="how-it-works-section"
      className="relative py-20 sm:py-28"
      style={{ background: "var(--fp-cream)" }}
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-[1fr_1.3fr] gap-12 lg:gap-20 items-start">
          <div className="lg:sticky lg:top-28">
            <span
              className="text-xs uppercase font-bold tracking-[0.22em]"
              style={{ color: "var(--fp-cognac)" }}
            >
              Notre promesse
            </span>
            <h2
              className="font-display font-semibold text-3xl sm:text-4xl lg:text-5xl mt-3 leading-[1.08]"
              style={{ color: "var(--fp-espresso)" }}
            >
              On prend ton ventre{" "}
              <span className="italic">au sérieux</span>,{" "}
              sans jamais te faire sentir bizarre.
            </h2>
            <p
              className="mt-5 text-base sm:text-lg"
              style={{ color: "var(--fp-ink-soft)", lineHeight: 1.65 }}
            >
              Floppy Poopy, c'est l'app qu'on aurait aimé avoir quand on nous
              a dit « il faudrait noter ça dans un carnet ». Chaleureuse,
              précise, et franchement un peu drôle.
            </p>
          </div>

          <div className="space-y-5">
            {points.map(({ Icon, title, desc }, i) => (
              <div
                key={title}
                data-testid={`how-it-works-point-${i}`}
                className="relative flex gap-5 p-6 rounded-3xl transition-transform duration-300 hover:translate-x-1"
                style={{
                  background: "#ffffff",
                  border: "1px solid var(--fp-border)",
                }}
              >
                <div
                  className="shrink-0 w-12 h-12 rounded-2xl flex items-center justify-center"
                  style={{
                    background: "var(--fp-cream)",
                    color: "var(--fp-terracotta)",
                    border: "1px solid var(--fp-border)",
                  }}
                >
                  <Icon size={22} strokeWidth={2.2} />
                </div>
                <div>
                  <h3
                    className="font-display text-lg font-semibold"
                    style={{ color: "var(--fp-espresso)" }}
                  >
                    {title}
                  </h3>
                  <p
                    className="text-sm mt-1"
                    style={{
                      color: "var(--fp-ink-soft)",
                      lineHeight: 1.6,
                    }}
                  >
                    {desc}
                  </p>
                </div>
                <div
                  className="absolute -top-3 -right-3 w-9 h-9 rounded-full flex items-center justify-center font-display font-bold text-sm"
                  style={{
                    background: "var(--fp-powder)",
                    color: "var(--fp-espresso)",
                    border: "3px solid var(--fp-cream)",
                  }}
                >
                  {i + 1}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
